export const isEmptyArray = (arr) => arr.length === 0;

export 	const getDefaultImageUrl = (images) => {
    const defaultImage = images?.filter((image) => image?.default === true);
    return defaultImage?.length > 0 ? defaultImage[0] : null;
  };